import { Collapse, Icon } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import TitleScroller from '../Home/TitleScroller';
import ViewInListLink from '../UI/ViewInListLink';
import { useReviews } from './containers/ReviewsDataStore';
import ReviewType from './ReviewType';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import { useHistory } from 'react-router-dom';
import LocalStorageKeys from '../Preferences/LocalStorageKeys';
import { useYourBooksDrawer } from '../YourBooks/YourBooksDrawerContext';

const Panel = Collapse.Panel;

ReviewsCollapse.propTypes = {
	isMobile: PropTypes.func,
};

function ReviewsCollapse({ isMobile }) {
	const history = useHistory();
	const yourBooksDrawer = useYourBooksDrawer();

	const localStorageKey = LocalStorageKeys.expandedReviewsPanels;
	const localStorageValue = localStorage.getItem(localStorageKey);

	const getReviewKeys = () => {
		return Object.keys(ReviewType).map(review => {
			return ReviewType[review].key;
		});
	};

	const [collapsedPanels, setCollapsedPanels] = React.useState(
		localStorageValue ? JSON.parse(localStorageValue) : getReviewKeys(),
	);
	const isMobileSize = isMobile();

	React.useEffect(() => {
		localStorage.setItem(localStorageKey, JSON.stringify(collapsedPanels));
	}, [collapsedPanels]);

	const reviewsDataStore = useReviews();
	const { isLoading, reviews } = reviewsDataStore.state;

	const getReviewsByRating = reviewType => {
		return (
			reviews &&
			reviews.filter(
				rv =>
					rv.rating >= reviewType.lowRating &&
					rv.rating <= reviewType.highRating,
			)
		);
	};

	const renderPanel = reviewType => {
		const filteredReviews = getReviewsByRating(reviewType);
		return (
			reviewType.showAsPanel &&
			((filteredReviews && filteredReviews.length > 0) ||
				reviewType.doShowIfZero) && (
				<Panel
					style={{ marginLeft: '-10px' }}
					header={reviewType.text}
					extra={filteredReviews.length}
					key={reviewType.key}>
					<TitleScroller
						titles={
							!isLoading && filteredReviews && filteredReviews
						}
						communityId={0}
					/>
					<div onClick={() => handleClick(reviewType.key)}>
						<ViewInListLink />
					</div>
				</Panel>
			)
		);
	};

	const handleClick = selectedKey => {
		reviewsDataStore.setSelectedMenuOption(selectedKey);
		history.push('/reviews');
		yourBooksDrawer && yourBooksDrawer.close();
	};

	const logChange = e => {
		setCollapsedPanels(e);
	};

	return (
		<>
			{reviews && reviews.length > 0 ? (
				<Collapse
					className={
						!isMobileSize
							? 'standard-collapse'
							: 'standard-collapse-mobile'
					}
					bordered={false}
					onChange={logChange}
					defaultActiveKey={collapsedPanels}
					activeKeys={collapsedPanels}
					expandIcon={({ isActive }) => (
						<Icon type="caret-right" rotate={isActive ? 90 : 0} />
					)}>
					{Object.keys(ReviewType).map(review => {
						return (
							ReviewType[review].showAsPanel &&
							renderPanel(ReviewType[review])
						);
					})}
				</Collapse>
			) : (
				<div className="no-content-text">
					Reviews you write will show up here
				</div>
			)}
		</>
	);
}

export default withIsMobile(ReviewsCollapse);
